module.exports = __webpack_public_path__ + "static/img/fdg.ba311be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdg.png
// module id = 2H6J
// module chunks = 1